import AddCarScreen from '../../components/AddCarScreen/AddCarScreen';

export default function UpdateCarPage() {
  return <AddCarScreen />;
}
